import { render } from "./CampaignMgmt.vue?vue&type=template&id=ccf28bde&scoped=true"
import script from "./CampaignMgmt.vue?vue&type=script&lang=js"
export * from "./CampaignMgmt.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-ccf28bde"

export default script